import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import {
  Nav,
  NavContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavBtn,
  NavBtnLink,
} from "./NavbarElements";

import Logo from "../../../assets/NonceLogo.png";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useWallet } from "../../../context/walletProvider";
//Web3
import mintSimpleCollectible from "../../../contracts/mintSimpleCollectible";

const Navbar = ({ toggle }) => {
  const history = useHistory();
  const wallet = useWallet();
  const [connected, setConnected] = React.useState(false);
  const handleConnect = async () => {
    wallet.setLoadingState(true);
    await wallet.connect();
    if (window.ethereum.isConnected()) {
      setConnected(true);
    }
    wallet.setLoadingState(false);
  };
  //TODO optimise this
  useEffect(() => {
    if (wallet.status === "connected") {
      setConnected(true);
    }
  }, [wallet]);

  // const handleConnectWallet = async () => {
  //   const web3 = new Web3(window.ethereum);

  //   //Use web3 to get the users account
  //   const account = await web3.eth.getAccounts();
  //   const collectibleContract = mintSimpleCollectible(account);

  //   try {
  //     let obj = await collectibleContract.approve(TO, 0);
  //     console.log(obj);
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };
  return (
    <>
      <Nav>
        <div style={{ width: "100vw", margin: "auto" }}>
          <Grid container spacing={0}>
            {/* <Grid item xs={3}> */}
            <NavMenu>
              <NavLinks to="/">
                <img
                  src={Logo}
                  style={{ height: "25px", marginRight: "10px" }}
                />
                <NavLogo>Nonce Finance</NavLogo>
              </NavLinks>
              <MobileIcon onClick={toggle}>
                <FaBars />
              </MobileIcon>
            </NavMenu>
            {/* </Grid> */}
            <Grid item xs={6} style={{ padding: "5px 0" }}>
              <NavMenu>
                <NavItem
                  disabled
                  // onClick={() => {
                  //   history.push("/collections");
                  // }}
                >
                  <NavLinks to="#">Learn</NavLinks>
                </NavItem>
                <NavItem
                  disabled
                  // onClick={() => {
                  //   history.push("/myNFT");
                  // }}
                >
                  <NavLinks to="#">Community</NavLinks>
                </NavItem>
                <NavItem
                  disabled
                  // onClick={() => {
                  //   history.push("/myNFT");
                  // }}
                >
                  <NavLinks to="/create">Create</NavLinks>
                </NavItem>
              </NavMenu>
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <NavMenu style={{ margin: "5px" }}>
                <NavLinks to="/myNFT">
                  <NavBtn style={{ textAlign: "center" }}>
                    <Button
                      style={{
                        fontSize: "0.7em",
                        fontWeight: "700",
                        letterSpacing: "2px",
                        color: "#555",
                        backgroundColor: "#000",
                      }}
                      variant="contained"
                      size="small"
                    >
                      
                    </Button>
                  </NavBtn>
                </NavLinks>
                <NavBtn style={{ textAlign: "center" }}>
                  {!connected ? (
                    <Button
                      style={{
                        borderRadius: "15px",
                        fontSize: "0.7em",
                        fontWeight: "700",
                        letterSpacing: "2px",
                        boxShadow: "0px 17px 17px rgba(255, 255, 255, 0.2)",
                      }}
                      //onClick={handleConnectWallet}
                      variant="contained"
                      size="small"
                      onClick={handleConnect}
                    >
                      Connect Wallet
                    </Button>
                  ) : (
                    <span
                      style={{
                        color: "#e0e0e0",
                        paddingLeft: "2px",
                      }}
                    >
                      {" "}
                      • connected
                    </span>
                  )}
                </NavBtn>
              </NavMenu>
            </Grid>
          </Grid>
        </div>
      </Nav>
    </>
  );
};

export default Navbar;
